import React from 'react';
import { Modal } from 'antd';
import { useAtom, useAtomValue } from 'jotai';
import { currentWebhookRowAtom, showHistoryAtom } from '../webhooksAtom';
import { HISTORY_LOG_TABLE_TITLE } from '../constant';
import { useQuery } from '@tanstack/react-query';
import { fetchWebhookChangeHistoryLogs } from '@src/api/notificationChannel';
import { get } from 'lodash';
import HistoryContent from './HistoryContent';
import { formatWebhookHistoryData } from './utils';

const WebhooksChangeHistoryLog = () => {
  const [showHistory, setShowHistory] = useAtom(showHistoryAtom);
  const currentWebhookRow = useAtomValue(currentWebhookRowAtom);

  const historyResponse: any = useQuery(
    ['webhook-history-log', currentWebhookRow.webhookId],
    () => {
      return fetchWebhookChangeHistoryLogs({ id: currentWebhookRow.webhookId }).then((response) => {
        const data = get(response, ['data'], {});
        return formatWebhookHistoryData(data);
      });
    },
    {
      enabled: currentWebhookRow.webhookId !== undefined && showHistory,
    },
  );

  return (
    <Modal
      width="80vw"
      title={HISTORY_LOG_TABLE_TITLE}
      open={showHistory}
      onCancel={() => setShowHistory(false)}
      footer={[]}
    >
      <HistoryContent {...historyResponse} webhook={currentWebhookRow} />
    </Modal>
  );
};

export default WebhooksChangeHistoryLog;
